import { connect } from 'react-redux';
import DeveloperConsole from './DeveloperConsole';
import { removeStreak, setStreak } from '../../actions/streaks';
import { setSessionLength, resetSessionLength } from '../../actions/session';
import { setCreatedAt } from '../../actions/fender-connect';
import { toggleFeatureFlag } from '../../actions/flags';

const mapState = state => {
  const { flags, fenderConnect, session } = state;
  const { email, firstName, lastName, loggedIn, subscriptions } = fenderConnect || {};
  const { play, createdAt } = subscriptions || {};
  const { console: isEnabled } = flags || {};
  const {
    durationForMilestone,
    error: streaksError,
    isLoading: isLoadingStreaks,
    results: streaksData,
  } = state.streaks || {};
  const { data: sessionData, sessionLengthInMins } = session || {};
  return {
    createdAt,
    email,
    durationForMilestone,
    firstName,
    isEnabled,
    isLoadingStreaks,
    lastName,
    loggedIn,
    sessionData,
    sessionLengthInMins,
    streaksData,
    streaksError,
    subscriptionStatus: play,
  };
};

const mapDispatch = {
  removeStreak,
  resetSessionLength,
  setSessionLength,
  setStreak,
  toggleFeatureFlag,
  setCreatedAt,
};

export default connect(
  mapState,
  mapDispatch,
)(DeveloperConsole);
